import { generatePath } from 'react-router-dom'

export function generateShopPath(requisitionId: string | number | null | undefined, advanced?: boolean | null) {
  return generatePath(`/requisitions/:requisitionId/shop${advanced ? '/advanced' : ''}`, {
    requisitionId: String(requisitionId),
  })
}
